module.exports = __webpack_public_path__ + "img/q-6-2@2x.646dff82.png";